import React from 'react';

function TickIcon({
  className,
}: BaseIcon): JSX.Element {
  return (
    <svg
      className={className}
      x="0px"
      y="0px"
      viewBox="0 0 11.000493 9.0008545"
    >
      <g id="BASE">
        <path
          d="M10.1351833,0.1578405L3.011502,7.7431192l-2.1259041-2.577755 C0.7096061,4.951385,0.39562,4.9223871,0.1816289,5.0973706c-0.2129903,0.175983-0.2429892,0.4909539-0.0669974,0.7039337 L2.6015205,8.818018C2.6935165,8.9290075,2.8275104,8.9950008,2.9705045,9C2.9765038,9,2.9825041,9,2.987504,9 c0.1379933,0,0.2699883-0.0569944,0.3639839-0.1579847l7.5126629-7.9992404 c0.1889906-0.2009811,0.1799917-0.5179509-0.0219984-0.7069326C10.6431599-0.0531395,10.3251753-0.0441405,10.1351833,0.1578405z"
        />
      </g>
    </svg>
  );
}

export default TickIcon;
